import React from 'react';

import Header from '@components/customise/option/header';
import OptionsList from './optionslist';

import '@styles/customise/option.scss';
import { VehicleColourProps } from 'interface';

const Trim: React.FC<VehicleColourProps> = ({
  currentStep,
  totalSteps,
  options,
}) => {
  return (
    <div className="customise-options__trim">
      <Header
        currentStep={currentStep}
        totalSteps={totalSteps}
        showWarning={true}
        title="Interior Fabric"
      />
      <OptionsList availableOptions={options} variant="trim" />
    </div>
  );
};

export default Trim;
